/* Coffrush — interacciones propias (prefijo cr-) */
(function () {
  if (window.__crInit) return;
  window.__crInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Formatea céntimos igual que el filtro money de Shopify en la moneda del visitante
  // (usa una muestra "1234,56" renderizada por Liquid para copiar símbolo y separadores)
  function formatMoney(cents) {
    var sample = window.crMoneySample || '1.234,56 €';
    var m = sample.match(/^(.*?)1([^0-9]?)234([^0-9])56(.*)$/);
    var value = (cents / 100).toFixed(2).split('.');
    if (!m) return sample.replace(/[0-9][0-9.,\s]*[0-9]/, value[0] + '.' + value[1]);
    var thousands = m[2], decimal = m[3];
    var int = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return m[1] + int + decimal + value[1] + m[4];
  }


  /* ---------- Reveals al hacer scroll (un solo observer) ---------- */
  var io = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.cr-reveal:not(.cr-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cr-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cr-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras animadas ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-cr-count]:not([data-done])');
    if (!els.length) return;
    var run = function (el) {
      el.setAttribute('data-done', '1');
      var target = parseFloat(el.getAttribute('data-cr-count')) || 0;
      if (reduce || target === 0) { el.textContent = el.getAttribute('data-cr-count'); return; }
      var dur = 1600, start = null;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Tarjetas con inclinación suave ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-cr-tilt]:not([data-tilt-on])').forEach(function (card) {
      card.setAttribute('data-tilt-on', '1');
      var max = parseFloat(card.getAttribute('data-cr-tilt')) || 6;
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateX(' + (-y * max) + 'deg) rotateY(' + (x * max) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-cr-parallax]');
    if (!els.length) return;
    var ticking = false;
    var update = function () {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-cr-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (r.top * -k / 100) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Selector de variantes (compra rápida y página de producto) ---------- */
  function initVariantPickers(root) {
    (root || document).querySelectorAll('[data-cr-product]:not([data-cr-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-cr-ready', '1');
      var dataEl = wrap.querySelector('script[data-cr-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = wrap.querySelector('input[name="id"]');
      var priceEls = wrap.querySelectorAll('[data-cr-price]');
      var oldEls = wrap.querySelectorAll('[data-cr-compare]');
      var saveEls = wrap.querySelectorAll('[data-cr-save]');
      var btns = wrap.querySelectorAll('[data-cr-add]');
      var updateUrl = wrap.hasAttribute('data-cr-url');
      var soldText = wrap.getAttribute('data-cr-sold') || 'Agotado';

      var selected = function () {
        var opts = [];
        wrap.querySelectorAll('[data-cr-option]').forEach(function (group) {
          var active = group.querySelector('.is-active');
          opts.push(active ? active.getAttribute('data-value') : null);
        });
        return opts;
      };

      var apply = function () {
        var opts = selected();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
        var hasSale = v.compare_at_price && v.compare_at_price > v.price;
        oldEls.forEach(function (el) {
          el.textContent = hasSale ? formatMoney(v.compare_at_price) : '';
          el.hidden = !hasSale;
        });
        saveEls.forEach(function (el) {
          el.hidden = !hasSale;
          if (hasSale) el.textContent = el.getAttribute('data-label').replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
        });
        btns.forEach(function (b) {
          if (!b.hasAttribute('data-label')) b.setAttribute('data-label', b.querySelector('[data-cr-btn-text]').textContent);
          b.disabled = !v.available;
          b.querySelector('[data-cr-btn-text]').textContent = v.available ? b.getAttribute('data-label') : soldText;
        });
        // imagen de la variante
        if (v.media_id) {
          var img = wrap.querySelector('[data-cr-media="' + v.media_id + '"]');
          if (img) {
            wrap.querySelectorAll('[data-cr-media]').forEach(function (m) { m.classList.remove('is-active'); });
            img.classList.add('is-active');
          }
          var thumb = wrap.querySelector('[data-cr-thumb="' + v.media_id + '"]');
          if (thumb) thumb.click();
        }
        if (v.swatch) wrap.style.setProperty('--cr-swatch-bg', v.swatch);
        if (updateUrl && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      };

      wrap.querySelectorAll('[data-cr-option]').forEach(function (group) {
        group.addEventListener('click', function (ev) {
          var b = ev.target.closest('[data-value]');
          if (!b) return;
          group.querySelectorAll('[data-value]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active');
          b.setAttribute('aria-pressed', 'true');
          var label = group.parentElement.querySelector('[data-cr-option-label]');
          if (label) label.textContent = b.getAttribute('data-value');
          apply();
        });
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-cr-gallery]:not([data-cr-ready])').forEach(function (g) {
      g.setAttribute('data-cr-ready', '1');
      var main = g.querySelector('[data-cr-main]');
      g.querySelectorAll('[data-cr-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('[data-cr-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.srcset = t.getAttribute('data-srcset') || '';
            main.alt = t.getAttribute('data-alt') || '';
            main.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  /* ---------- Cantidad ---------- */
  function initQty(root) {
    (root || document).querySelectorAll('[data-cr-qty]:not([data-cr-ready])').forEach(function (q) {
      q.setAttribute('data-cr-ready', '1');
      var input = q.querySelector('input');
      q.addEventListener('click', function (ev) {
        var b = ev.target.closest('button');
        if (!b) return;
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + (b.getAttribute('data-step') === '+' ? 1 : -1));
      });
    });
  }

  /* ---------- Barra de compra fija en móvil ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-cr-sticky-buy]');
    var target = document.querySelector('[data-cr-buy-anchor]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-shown', past);
      });
    }).observe(target);
    bar.querySelector('button').addEventListener('click', function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }


  /* ---------- Imágenes superpuestas con barra ---------- */
  function initMix(root) {
    (root || document).querySelectorAll('[data-cr-mix]:not([data-mix-on])').forEach(function (el) {
      el.setAttribute('data-mix-on', '1');
      var frame = el.querySelector('[data-cr-mix-frame]');
      var track = el.querySelector('[data-cr-mix-track]');
      var thumb = el.querySelector('[data-cr-mix-thumb]');
      var labels = [].slice.call(el.querySelectorAll('[data-cr-mix-go]'));
      var details = [].slice.call(el.querySelectorAll('.cr-mix__detail'));
      var value = 50, active = -1, dragging = false;

      // v = 0 → primera imagen entera; 50 → las tres; 100 → la tercera entera
      function set(v) {
        value = Math.max(0, Math.min(100, v));
        var w = 100 - value;
        var e1 = Math.max(0, Math.min(100, 1.5 * w - 50));
        var e2 = Math.max(0, Math.min(100, 1.5 * w));
        el.style.setProperty('--cr-v', value.toFixed(2));
        el.style.setProperty('--cr-e1', e1.toFixed(2));
        el.style.setProperty('--cr-e2', e2.toFixed(2));
        thumb.setAttribute('aria-valuenow', Math.round(value));
        var a = value < 33.4 ? 0 : value > 66.6 ? 2 : 1;
        if (a !== active) {
          active = a;
          labels.forEach(function (l, k) { l.classList.toggle('is-active', k === a); });
          details.forEach(function (d, k) { d.classList.toggle('is-active', k === a); });
          thumb.setAttribute('aria-valuetext', labels[a] ? labels[a].textContent : '');
        }
      }
      function fromTrack(x) {
        var r = track.getBoundingClientRect();
        return (x - r.left) / r.width * 100;
      }
      function fromFrame(x) {
        // Arrastrar sobre la foto: la mitad derecha muestra las de la derecha
        var r = frame.getBoundingClientRect();
        return (x - r.left) / r.width * 100;
      }
      function start(e, map) {
        if (e.button !== undefined && e.button !== 0) return;
        if (e.target.closest('[data-cr-mix-go]')) return;
        dragging = true;
        el.classList.add('is-dragging');
        var target = e.currentTarget;
        try { target.setPointerCapture(e.pointerId); } catch (err) {}
        set(map(e.clientX));
        function move(ev) { if (dragging) set(map(ev.clientX)); }
        function end() {
          dragging = false;
          el.classList.remove('is-dragging');
          target.removeEventListener('pointermove', move);
          target.removeEventListener('pointerup', end);
          target.removeEventListener('pointercancel', end);
        }
        target.addEventListener('pointermove', move);
        target.addEventListener('pointerup', end);
        target.addEventListener('pointercancel', end);
      }
      var bar = el.querySelector('.cr-mix__bar');
      track.addEventListener('pointerdown', function (e) { e.stopPropagation(); start(e, fromTrack); });
      frame.addEventListener('pointerdown', function (e) {
        if (bar.contains(e.target)) return;
        // En móvil, solo la barra; así el dedo puede seguir bajando la página
        if (e.pointerType === 'touch') return;
        start(e, fromFrame);
      });
      labels.forEach(function (l, k) { l.addEventListener('click', function () { set(k * 50); }); });
      thumb.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 25 : 5;
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); set(value + step); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); set(value - step); }
        if (e.key === 'Home') { e.preventDefault(); set(0); }
        if (e.key === 'End') { e.preventDefault(); set(100); }
      });
      // Editor de Shopify: al seleccionar un bloque, mostrar esa imagen
      [].slice.call(el.querySelectorAll('.cr-mix__layer')).forEach(function (layer, k) {
        layer.addEventListener('shopify:block:select', function () { set(k * 50); });
      });
      el.classList.add('is-dragging');
      set(50);
      requestAnimationFrame(function () { el.classList.remove('is-dragging'); });
    });
  }

  /* ---------- Recuadro con barra lateral: cambia la imagen ---------- */
  function initSwitchers(root) {
    (root || document).querySelectorAll('[data-cr-switch]:not([data-switch-on])').forEach(function (el) {
      el.setAttribute('data-switch-on', '1');
      var items = [].slice.call(el.querySelectorAll('[data-cr-switch-to]'));
      var details = [].slice.call(el.querySelectorAll('.cr-switch__detail'));
      var imgs = [].slice.call(el.querySelectorAll('.cr-switch__img'));
      var n = items.length, current = 0;
      if (!n) return;
      var auto = el.hasAttribute('data-autoplay') && !reduce && n > 1;

      function show(i) {
        current = (i + n) % n;
        items.forEach(function (t, k) { t.classList.toggle('is-active', k === current); t.setAttribute('aria-selected', k === current ? 'true' : 'false'); });
        details.forEach(function (d, k) { d.classList.toggle('is-active', k === current); d.setAttribute('aria-hidden', k === current ? 'false' : 'true'); });
        imgs.forEach(function (m, k) { m.classList.toggle('is-active', k === current); });
      }
      items.forEach(function (t, k) {
        t.addEventListener('click', function () { show(k); });
        t.addEventListener('keydown', function (e) {
          var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
          if (!d) return;
          e.preventDefault(); show(current + d); items[current].focus();
        });
        // Al terminar de llenarse la barra, pasa a la siguiente
        t.querySelector('.cr-switch__fill').addEventListener('animationend', function () { if (k === current) show(current + 1); });
        // Editor de Shopify: al seleccionar el bloque, mostrarlo
        t.addEventListener('shopify:block:select', function () { show(k); el.classList.add('is-paused'); });
        t.addEventListener('shopify:block:deselect', function () { el.classList.remove('is-paused'); });
      });
      if (!auto) return;
      // Solo avanza cuando se ve en pantalla y no hay ratón encima
      var visible = false, hover = false;
      function sync() { el.classList.toggle('is-paused', !visible || hover); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(el);
      } else { visible = true; }
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        el.addEventListener('mouseenter', function () { hover = true; sync(); });
        el.addEventListener('mouseleave', function () { hover = false; sync(); });
      }
      el.addEventListener('focusin', function () { hover = true; sync(); });
      el.addEventListener('focusout', function () { hover = false; sync(); });
      sync();
      el.classList.add('is-auto');
    });
  }

  /* ---------- Carrusel horizontal (scroll-snap nativo) ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-cr-slider]:not([data-slider-on])').forEach(function (el) {
      el.setAttribute('data-slider-on', '1');
      var vp = el.querySelector('[data-cr-slider-viewport]');
      var slides = [].slice.call(vp.children);
      var tabs = [].slice.call(el.querySelectorAll('[data-cr-slide-to]'));
      var prev = el.querySelector('[data-cr-slider-prev]');
      var next = el.querySelector('[data-cr-slider-next]');
      var bar = el.querySelector('[data-cr-slider-bar]');
      var n = slides.length, current = -1;
      if (!n) return;

      function setCurrent(i) {
        if (i === current) return;
        current = i;
        slides.forEach(function (s, k) { s.classList.toggle('is-current', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === n - 1;
        if (bar) bar.style.transform = 'scaleX(' + ((i + 1) / n) + ')';
        var tab = tabs[i];
        if (tab && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
          tab.parentElement.scrollTo({ left: tab.offsetLeft - 12, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      function goTo(i) {
        i = Math.max(0, Math.min(n - 1, i));
        var s = slides[i];
        vp.scrollTo({ left: s.offsetLeft - (vp.clientWidth - s.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        setCurrent(i);
      }
      function nearest() {
        var mid = vp.scrollLeft + vp.clientWidth / 2, best = 0, dist = Infinity;
        slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid); if (d < dist) { dist = d; best = k; } });
        return best;
      }
      var ticking = false;
      vp.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { ticking = false; setCurrent(nearest()); });
      }, { passive: true });
      tabs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-cr-slide-to')); }); });
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      vp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      slides.forEach(function (s, k) { s.addEventListener('click', function () { if (k !== current) goTo(k); }); });
      // Editor de Shopify: al seleccionar un bloque, mostrar su diapositiva
      el.addEventListener('shopify:block:select', function (e) { var k = slides.indexOf(e.target); if (k > -1) goTo(k); });
      setCurrent(0);
    });
  }

  /* ---------- Comparador deslizante (arrastrar, teclado y pequeña pista al aparecer) ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-cr-cmp]:not([data-cmp-on])').forEach(function (el) {
      el.setAttribute('data-cmp-on', '1');
      var frame = el.querySelector('[data-cr-cmp-frame]');
      var handle = el.querySelector('[data-cr-cmp-handle]');
      if (!frame || !handle) return;
      var pos = parseFloat(el.getAttribute('data-start')) || 50;
      function set(p) {
        pos = Math.max(0, Math.min(100, p));
        el.style.setProperty('--pos', pos + '%');
        handle.setAttribute('aria-valuenow', Math.round(pos));
      }
      function fromX(x) { var r = frame.getBoundingClientRect(); return (x - r.left) / r.width * 100; }
      set(pos);
      var dragging = false, startX = 0, startY = 0, decided = false;
      frame.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        dragging = true; decided = e.pointerType !== 'touch'; startX = e.clientX; startY = e.clientY;
        el.classList.remove('is-animating');
        if (decided) { el.classList.add('is-dragging'); try { frame.setPointerCapture(e.pointerId); } catch (err) {} set(fromX(e.clientX)); }
      });
      frame.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          // En móvil: solo arrastra si el gesto es horizontal; si es vertical, deja bajar la página
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { dragging = false; return; }
          decided = true; el.classList.add('is-dragging');
          try { frame.setPointerCapture(e.pointerId); } catch (err) {}
        }
        set(fromX(e.clientX));
      });
      function end() { dragging = false; el.classList.remove('is-dragging'); }
      frame.addEventListener('pointerup', end);
      frame.addEventListener('pointercancel', end);
      handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 20 : 5;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); set(pos - step); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); set(pos + step); }
        if (e.key === 'Home') { e.preventDefault(); set(0); }
        if (e.key === 'End') { e.preventDefault(); set(100); }
      });
      // Pista: al verse por primera vez, la barra se mueve un poco para indicar que se puede arrastrar
      if (!reduce && 'IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          io2.disconnect();
          var base = pos;
          setTimeout(function () { if (dragging) return; el.classList.add('is-animating'); set(base - 12); }, 500);
          setTimeout(function () { if (dragging) return; set(base + 10); }, 1250);
          setTimeout(function () { if (dragging) return; set(base); }, 2000);
          setTimeout(function () { el.classList.remove('is-animating'); }, 2750);
        }, { threshold: 0.5 });
        io2.observe(el);
      }
    });
  }

  /* ---------- Botón flotante: aparece al bajar, se oculta sobre el pie ---------- */
  function initFloat(root) {
    (root || document).querySelectorAll('[data-cr-float]:not([data-float-on])').forEach(function (btn) {
      btn.setAttribute('data-float-on', '1');
      if (btn.parentNode !== document.body && !btn.closest('[data-shopify-editor-section]')) document.body.appendChild(btn);
      var offset = parseFloat(btn.getAttribute('data-offset')) || 0;
      var footer = document.querySelector('.cr-footer, footer');
      var ticking = false;
      function update() {
        ticking = false;
        var past = window.scrollY > offset;
        var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight - 40;
        btn.classList.toggle('is-shown', past && !nearFooter);
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initAll(root) {
    initReveals(root);
    initCounters(root);
    initTilt(root);
    initVariantPickers(root);
    initGallery(root);
    initQty(root);
    initFloat(root);
    initCompare(root);
    initSliders(root);
    initSwitchers(root);
    initMix(root);
  }

  function boot() { initAll(document); initParallax(); initStickyBuy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Editor de Shopify: re-inicializar cuando se edita una sección
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
